import React from 'react';
import './RatingPage.scss';
import { useAppDispatch, useAppSelector } from 'store/store';
import { asyncFetchUsers } from 'store/reducers/users/thunks';
import { IUser } from 'store/reducers/users/types';

function UserRatingCard({ user }: { user: IUser }): React.ReactElement {
    const { first_name: firstName, last_name: lastName, frogs } = user;
    return (
        <div className="user-rating-card">
            <div className="user-rating-card_name">
                {firstName} {lastName}
            </div>
            <div className="user-rating-card_score"> {frogs}</div>
        </div>
    );
}

function RatingPage(): React.ReactElement {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(asyncFetchUsers());
    }, [dispatch]);

    const { users } = useAppSelector(state => state.usersStore);

    return (
        <div className="rating-page">
            {users.map(user => {
                return <UserRatingCard key={user.id} user={user} />;
            })}
        </div>
    );
}

export default React.memo(RatingPage);
